import { createSelector } from 'reselect/lib/index'

const getErrorsSlice = (state) => {
  return state.errors
}

export const makeGetError = () => {
  return createSelector(
    [getErrorsSlice, (_, domId) => domId],
    (errors, domId) => {
      return errors[domId]
    },
  )
}
